import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';

import type { TierOffer } from '@avalara/types/index';
import type { TierPlan } from '@avalara/types/index';

import type { ReactNode } from 'react';
import {
  ExtractorActiveTierCheckMark,
  ExtractorPickerButtonContainer,
  ExtractorPickerInfo,
  ExtractorPickerPrice,
  ExtractorPickerQuantity,
  PickerInfoContainer,
  TierPlanButton,
} from '../../styled/components/buy-flow';

type Props = {
  onSelectProduct: (_: TierPlan) => void;
  selectedProduct: TierPlan | null;
  tier?: TierPlan;
  title: {
    pre?: string;
    emp?: string;
    end?: string;
  };
  frequency?: 'annually';
  isSupportTile?: boolean;
};

const TierComponent = ({ onSelectProduct, selectedProduct, tier, title, frequency, isSupportTile }: Props) => {
  // The following var usage is done this way to eliminate the errors around multiple components per file.
  let tierButton: ReactNode;
  let priceMessage = '';
  let selected = false;
  let tmpTier: Partial<TierOffer> = { id: 'support', tierNumber: undefined, quantity: 0 };

  // all logic to differentiate between normal tier and support
  if (isSupportTile) {
    tierButton = (
      <>
        <p>{t('client.general.call-to-learn-more')}</p>
        <a href='tel://(877) 224-3650' style={{ color: 'var(--color-blue-darker)' }}>
          (877) 224-3650
        </a>
      </>
    );
    priceMessage = 'Avalara has plans for any size business.';
  } else if (tier) {
    selected = Boolean(selectedProduct && selectedProduct.quantity === tier.quantity);
    [priceMessage] = tier.recurringPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).split('.');
    if (selected) {
      tierButton = (
        <TierPlanButton className='active ghost'>
          <ExtractorActiveTierCheckMark>
            <SIcon name='check' />
          </ExtractorActiveTierCheckMark>
        </TierPlanButton>
      );
    } else {
      tierButton = (
        <button
          type='button'
          id={`button-${tier.quantity}`}
          className='default primary'
          onClick={() => onSelectProduct(tier)}
        >
          {t('client.buttons.select')}
        </button>
      );
    }
    tmpTier = tier;
  }

  return (
    <PickerInfoContainer id={`${tmpTier.id}tier${tmpTier.tierNumber}`}>
      <ExtractorPickerInfo selected={selected}>
        <ExtractorPickerQuantity>
          <p>
            {title.pre || ''}
            <strong>{title.emp || ''}</strong>
            {title.end || ''}
          </p>
        </ExtractorPickerQuantity>
        <ExtractorPickerPrice peryear={frequency ? `paid ${frequency}` : undefined} isSupportTile={isSupportTile}>
          <p className={`tierPriceFor${tmpTier.quantity}`}>{priceMessage}</p>
        </ExtractorPickerPrice>
        <ExtractorPickerButtonContainer isSupportTile={isSupportTile}>{tierButton}</ExtractorPickerButtonContainer>
      </ExtractorPickerInfo>
    </PickerInfoContainer>
  );
};

export default TierComponent;
